exports = module.exports = require("../../../../css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "html[dir] ._3LFIbcgJL0u7AWuA5QQwsZ{padding:10px}._21pkYbDYLU2hcXHZPsucsN{display:block!important}#calendarPrintableItem ._21pkYbDYLU2hcXHZPsucsN{display:-webkit-box!important;display:-ms-flexbox!important;display:flex!important}html[dir=ltr] ._3K34HQqbi_vRAGvUJY4P2o{padding-left:45px}html[dir=rtl] ._3K34HQqbi_vRAGvUJY4P2o{padding-right:45px}", ""]);
// Exports
exports.locals = {
	"preview": "_3LFIbcgJL0u7AWuA5QQwsZ",
	"scrollingPrintPage": "_21pkYbDYLU2hcXHZPsucsN",
	"agendaScrollingPrintPage": "_3K34HQqbi_vRAGvUJY4P2o"
};